import Book from "./book";
import EpubCFI from "./epubcfi";
import Rendition from "./rendition";
import Contents from "./contents";
import Layout from "./layout";
import ePub from "./epub";

export default ePub;
export {
	Book,
	EpubCFI,
	Rendition,
	Contents,
	Layout
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/epubjs/src/index.js
// module id = VXRH
// module chunks = 2